var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-button',_vm._b({attrs:{"type":_vm.buttonType,"icon":_vm.icon,"size":"mini"},on:{"click":function($event){return _vm.$emit('button-view-click')}}},'el-button',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }